import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <UpdatesSection />
        <MediaSection />
        <IndexSection />
        <FaqSection />
        <ContactSection />
        <RankingSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
      </main>

      <Footer />
    </div>
  );
}